import React, { useState, useEffect, useCallback } from 'react'
import {
    CommunityLeadSaveUserPropertyApi, CommunityLeadGetUserPropertyByUserIdApi,
    CommunityLeadGetUserPropertyByLoanIdApi, CommunityLeadDeleteUserPropertyApi, getZipBranchDetailApi
} from './AddLeadActionCreator'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import InputField from '../../CommonComponents/InputMUI'
import SelectField from '../../CommonComponents/SelectMUI'
// import Routes from '../../../../Layout/Routes'
import { typeOfPropertyArr, WEBSITE } from '../../CommonUtils'
import { useLocation, useNavigate } from 'react-router-dom'
import DeletePopup from '../deletePopup'

const EsignConfig = ({ data,handleTab , handlePage}) => {
    const [startingData, setStartingData] = useState({ userId: '', loanId: '', typeOfProperty: '', rentalIncome: '', address: '', pincode: '', city: '', state: '' })
    const [objectData, setObjectData] = useState([])
    const [loaderState, setLoaderState] = useState(false)
    const [, updateState] = useState();
    const forceUpdate = useCallback(() => updateState({}), []);
    const navigate = useNavigate();
    const location = useLocation();
    const [validationMsg, setValidationMsg] = useState({ status: true, msg: '', field: '' })
    const [deletePopupState, setDeletePopupState] = useState(false)
    const [idForDelete, setIdForDelete] = useState('')

    useEffect(() => {

        if (data !== null && data.rowData !== undefined) {
            let changeStartingData = { ...startingData }
            changeStartingData.userId = data.rowData.userId
            if (data.rowData.loanId !== undefined) {
                changeStartingData.loanId = data.rowData.loanId
            }
            setStartingData(changeStartingData)
            objectData[0] = changeStartingData
            setObjectData(objectData)
            getDetail()
        }
    }, [])

    const getDetail = () => {
        CommunityLeadGetUserPropertyByUserIdApi(data.rowData.userId,
            callBack => {
                // console.log(callBack.data)
                if (callBack.data !== null && callBack.data.length > 0) {
                    callBack.data.forEach((element, i) => {
                        objectData[i] = element
                    })
                    setObjectData(objectData)
                    forceUpdate()
                }
            }, error => {

            })
    }

    const inputChange = (e, type, mainKey) => {
        let changeObjectData = { ...objectData[mainKey] }
        if (type === 'pincode') {
            changeObjectData[type] = e

            if (e.length === 6) {
                const data = {
                    code: e,
                    type: 'zip'
                }
                setLoaderState(true)

                getZipBranchDetailApi(data, callBack => {
                    if (callBack.status === 'success') {
                        let changeObjectData = { ...objectData[mainKey] }
                        changeObjectData[type] = e
                        if (type === 'pincode') {
                            changeObjectData.city = callBack.destrict
                            changeObjectData.state = callBack.state
                        }
                        objectData[mainKey] = changeObjectData
                        setObjectData(objectData)
                        setLoaderState(false)

                        forceUpdate()
                    } else {
                        setLoaderState(false)
                        changeObjectData.city = ''
                        changeObjectData.state = ''
                        alert('Please enter correct pincode')
                    }
                }, error => {

                })
            } else {
                changeObjectData.city = ''
                changeObjectData.state = ''
            }
        } else {
            changeObjectData[type] = e
        }
        if (type === 'pincode' && e === '') {
            changeObjectData.city = ''
            changeObjectData.state = ''
        }
        objectData[mainKey] = changeObjectData
        setObjectData(objectData)
        setValidationMsg({})
    }

    const mainActionHandler = (type, mainKey) => {
        if (type === 'mainAdd') {
            if (objectData.typeOfProperty && objectData.rentalIncome && objectData.address && objectData.pincode) {
                objectData[mainKey + 1] = startingData
                setObjectData(objectData)
                forceUpdate()
            }
        } else if (type === 'mainRemove') {
            if (objectData.length > 1 && objectData[mainKey] !== undefined) {
                if (objectData[mainKey].id !== undefined && objectData[mainKey].id !== null && objectData[mainKey].id !== '') {
                    setIdForDelete(objectData[mainKey].id)
                    // setDeletePopupState(true)
                    CommunityLeadDeleteUserPropertyApi(objectData[mainKey].id,
                        callBack => {
                            // console.log(callBack)
                            if (callBack.message === 'success') {
                                objectData.splice(mainKey, 1)
                                setObjectData(objectData)
                                forceUpdate()
                            }
                        }, error => {

                        })
                } else {
                    objectData.splice(mainKey, 1)
                    setObjectData(objectData)
                    forceUpdate()
                }
            }
        }

    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            CommunityLeadDeleteUserPropertyApi(idForDelete,
                callBack => {

                }, error => {

                })
        }
        setDeletePopupState(false)
    }

    const validationHandler = (data) => {
        var SPACECHECK = /^[a-zA-Z][\sa-zA-Z]*/

        let formStatus = true
        // for (let i = 0; i < data.length; i++) {
        //     if (data[i].typeOfProperty === '' || data[i].typeOfProperty === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Type Of Property', field: 'typeOfProperty' + i })
        //         break
        //     }
        //     if (data[i].rentalIncome === '' || data[i].rentalIncome === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Rental Income', field: 'rentalIncome' + i })
        //         break
        //     }
        //     if (data[i].address === '' || data[i].address === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Address', field: 'address' + i })
        //         break
        //     } if (!SPACECHECK.test(data[i].address)) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'enter valid Address', field: 'address' + i })
        //         break
        //     }
        //     if (data[i].pincode === '' || data[i].pincode === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter Pincode', field: 'pincode' + i })
        //         break
        //     }
        //     if (data[i].city === '' || data[i].city === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter City', field: 'city' + i })
        //         break
        //     }

        //     if (data[i].state === '' || data[i].state === null) {
        //         formStatus = false
        //         setValidationMsg({ status: false, msg: 'Please enter State', field: 'state' + i })
        //         break
        //     }
        // }
        return formStatus
    }

    const saveHandler = (e) => {
        if (e === 'save') {
            if (validationHandler(objectData)) {
                setLoaderState(true)
                objectData.forEach((element, i) => {
                    // console.log(i)
                    // console.log(objectData.length - 1)
                    CommunityLeadSaveUserPropertyApi(element, Callback => {
                        // console.log(Callback)
                        if (i === (objectData.length - 1)) {
                            if (data.rowData.loanId !== undefined) {
                                Callback.data.loanId = data.rowData.loanId
                            }
                            Callback.data.sourceOfIncome = data.rowData.sourceOfIncome
                            if (!window.location.href.includes("/external")) {
                                // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_ADDRESS : Routes.COMMUNITY_ADD_LEAD_ADDRESS, { state: { rowData: Callback.data, communityId: location.state ? location.state.communityId : null, qrId : location.state ? location.state.qrId : null } })
                                const obj= { rowData: Callback.data, communityId: data ? data.communityId : null, qrId : data ? data.qrId : null }
                                handleTab("addLeadAddress",obj)
                            }
                          

                            setLoaderState(false)
                        }
                    }, error => {
                        // console.log(error)
                    })
                })
            }
        } else if (e === 'close') {
            // if (location.state ? location.state.communityId : null) {
            //     let data = location.state.rowData
            //     data.communityId = location.state ? location.state.communityId : null
            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // } else if (location.state ? location.state.qrId : null) {
            //     let data = location.state.rowData
            //     data.qrId = location.state ? location.state.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else {
            //     if (window.location.href.includes('admin')) {
            //         navigate(Routes.SUPER_ADMIN_ALL_LEADS)
            //     } else {
            //         navigate(Routes.COMMUNITY_ALL_LEADS)
            //     }
            // }
            handlePage("","list")
        } else if (e === 'back') {
            // if (!window.location.href.includes('/external')) {
            //     navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_PERSONAL : Routes.COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: location.state.rowData, communityId: location.state ? location.state.communityId : null } })
            // } else {
            //     navigate(Routes.EXTERNAL_COMMUNITY_ADD_LEAD_PERSONAL, { state: { rowData: location.state.rowData } })
            // }

            const obj = { rowData: data.rowData, communityId: data ? data.communityId : null }
            handleTab("personal",obj)
        }
    }

    // console.log(objectData)

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            {deletePopupState ?
                <DeletePopup
                    deleteHandler={deleteHandler}
                />
                : null}
            <div style={{ fontSize: '13px', marginLeft: '11px', marginTop: '10px' }} >Add Property Details</div >
            {/* {console.log(objectData, 'objectData')} */}
            {objectData.map((data, i) => {
                return (
                    <div key={i} className="card" style={{ marginTop: '15px' }}>
                        <div className='card-header'>
                            <div className='btn-group'>
                                <button
                                    className='cred-btn center-block '
                                    onClick={e => mainActionHandler('mainAdd', i)}
                                    style={{marginRight:'12px'}}
                                ><i className='fa fa-plus' /></button>
                                <button
                                    className='cred-btn center-block'
                                    onClick={e => mainActionHandler('mainRemove', i)}
                                ><i className='fa fa-minus' /></button>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-sm-6 col-xs-12 ' style={{marginBottom:'12px'}}>
                                    <SelectField
                                        label={'Type Of Property'}
                                        onChange={e => inputChange(e, 'typeOfProperty', i)}
                                        id="typeOfProperty"
                                        value={data.typeOfProperty}
                                        name="typeOfProperty"
                                        data={typeOfPropertyArr}
                                        size={'small'}
                                    />
                                    <div id="typeOfPropertyHelp" className="form-text text-danger">{validationMsg.field === 'typeOfProperty' + i ? validationMsg.msg : ""}</div>
                                </div>
                                <div className='col-sm-6 col-xs-12 'style={{marginBottom:'12px'}}>
                                    <InputField
                                        label="Rental Income (per month)"
                                        variant="outlined"
                                        value={data.rentalIncome}
                                        name="rentalIncome"
                                        id="rentalIncome"
                                        type="number"
                                        onChange={e => inputChange(e, 'rentalIncome', i)}
                                        size="small"
                                    />
                                    <div id="rentalIncomeHelp" className="form-text text-danger">{validationMsg.field === 'rentalIncome' + i ? validationMsg.msg : ""}</div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                                    <InputField
                                        label="Address"
                                        variant="outlined"
                                        value={data.address}
                                        name="address"
                                        id="address"
                                        type="text"
                                        onChange={e => inputChange(e, 'address', i)}
                                        size="small"
                                    />
                                    <div id="addressHelp" className="form-text text-danger">{validationMsg.field === 'address' + i ? validationMsg.msg : ""}</div>
                                </div>
                                <div className='col-sm-6 col-xs-12 'style={{marginBottom:'12px'}}>
                                    <InputField
                                        label="Pincode"
                                        variant="outlined"
                                        value={data.pincode}
                                        name="pincode"
                                        id="pincode"
                                        type="number"
                                        onChange={e => inputChange(e, 'pincode', i)}
                                        size="small"
                                    />
                                    <div id="pincodeHelp" className="form-text text-danger">{validationMsg.field === 'pincode' + i ? validationMsg.msg : ""}</div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-6 col-xs-12'>
                                    <InputField
                                        label="City"
                                        variant="outlined"
                                        value={data.city}
                                        name="city"
                                        id="city"
                                        type="text"
                                        onChange={e => inputChange(e, 'city', i)}
                                        size="small"
                                    />
                                    <div id="cityHelp" className="form-text text-danger">{validationMsg.field === 'city' + i ? validationMsg.msg : ""}</div>
                                </div>
                                <div className='col-sm-6 col-xs-12'>
                                    <InputField
                                        label="State"
                                        variant="outlined"
                                        value={data.state}
                                        name="state"
                                        id="state"
                                        type="text"
                                        onChange={e => inputChange(e, 'state', i)}
                                        size="small"
                                    />
                                    <div id="stateHelp" className="form-text text-danger">{validationMsg.field === 'state' + i ? validationMsg.msg : ""}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            <div className='row ' style={{margin:'12px 0'}}>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default EsignConfig;